import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";
import Index from "./Componets/Home.jsx/Index";
import About from "./Componets/About-Us/About";
import FAQ from "./Componets/FAQ/FAQ";
import BuyNFT from "./Componets/Buy-NFT/BuyNFT";
// import Login from "./Componets/Connect-Wallet/Login";
import ConnectWallet from "./Componets/Connect-Wallet/ConnectWallet";
import Roadmap from "./Componets/Roadmap/Roadmap";
import TermsConditions from "./Componets/TermsConditions";
import PrivacyPolicy from "./Componets/Privacy-Policy/PrivacyPolicy";

function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/about-us" element={<About />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/buy-nft" element={<BuyNFT />} />
          {/* <Route path="/login" element={<Login />} /> */}
          <Route path="/account" element={<ConnectWallet />} />
          <Route path="/roadmap" element={<Roadmap />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-and-conditions" element={<TermsConditions />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
